import { GetStaticProps } from 'next';
import Head from 'next/head';
import PrivacyPolicyComponent from '../src/components/PrivacyPolicy';
import { getCanonicalUrl } from '../src/utils/seoHelpers';
import { seoConfig } from '../src/config/seo.config';

export default function PrivacyPolicyPage() {
  const pageTitle = "Privacy Policy - TurfBooking.in";
  const pageDescription = "Read TurfBooking.in's Privacy Policy. Learn how we collect, use, and protect your personal information when you use our turf booking platform.";
  const canonicalUrl = getCanonicalUrl('/privacy-policy');
  const baseUrl = seoConfig.baseUrl;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content="turfbooking privacy policy, data protection, user privacy, booking data security" />
        <link rel="canonical" href={canonicalUrl} />
        
        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={`${baseUrl}/TBlogo.png`} />
        
        {/* Twitter */}
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        
        {/* Prevent indexing of policy pages (optional, but common practice) */}
        <meta name="robots" content="noindex, follow" />
      </Head>
      <PrivacyPolicyComponent />
    </>
  );
}

// Converted to getStaticProps for static generation at build time
// This improves performance by pre-rendering the page instead of SSR on every request
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
